import * as React from 'react';

import { useIntl } from 'react-intl';

import SimulateLPRDetectionFormModal from 'src/features/actions/components/form/SimulateLPRDetectionFormModal';
import { actionsMessages } from 'src/features/actions/utils/messages';
import {
    GeneralBlockHead,
    GeneralBlockHeader,
    GeneralBlockSubtitle,
    GeneralBlockTitle,
} from 'src/registry/components/blocks/GeneralBlock';
import {
    SectionBlock,
    SectionBlockBody,
    SectionBlockHead,
    SectionBlockHeader,
    SectionBlockSeparator,
    SectionBlockSubtitle,
    SectionBlockTitle,
} from 'src/registry/components/blocks/SectionBlock';
import SquareIcon from 'src/registry/components/blocks/SquareIcon';
import { Button } from 'src/registry/ui/Button';
import { useTitleStore } from 'src/stores/useTitleStore';
import { ICON_MAP } from 'src/utils/constants';

const Actions = () => {
    const { formatMessage } = useIntl();
    const { setTitle, removeTitle } = useTitleStore();
    const [isLPRModalOpen, setIsLPRModalOpen] = React.useState<boolean>(false);

    React.useEffect(() => {
        setTitle(formatMessage(actionsMessages.actions));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);
    return (
        <>
            <SectionBlock>
                <SectionBlockHeader>
                    <SectionBlockHead>
                        <SectionBlockTitle>{formatMessage(actionsMessages.lpr)}</SectionBlockTitle>
                        <SectionBlockSubtitle className="max-w-fit">
                            {formatMessage(actionsMessages.lprSectionDescription)}
                        </SectionBlockSubtitle>
                    </SectionBlockHead>
                </SectionBlockHeader>
                <SectionBlockSeparator />
                <SectionBlockBody className='grid grid-cols-1 lg:grid-cols-2'>
                    <Button
                        onClick={() => setIsLPRModalOpen(true)}
                        variant='outline'
                        className="flex h-auto min-w-full justify-start gap-4 rounded-xl border border-gray-200 bg-white p-4 text-left font-normal hover:bg-gray-100 cursor-pointer"
                    >
                        <GeneralBlockHeader>
                            <SquareIcon icon={ICON_MAP.CAMERA} />
                            <GeneralBlockHead>
                                <GeneralBlockTitle className="text-base text-gray-900">
                                    {formatMessage(actionsMessages.lprDetection)}
                                </GeneralBlockTitle>
                                <GeneralBlockSubtitle>
                                    {formatMessage(actionsMessages.lprDetectionDescription)}
                                </GeneralBlockSubtitle>
                            </GeneralBlockHead>
                        </GeneralBlockHeader>
                    </Button>
                </SectionBlockBody>
            </SectionBlock>
            {isLPRModalOpen && (
                <SimulateLPRDetectionFormModal isModalOpen={isLPRModalOpen} setIsModalOpen={setIsLPRModalOpen} />
            )}
        </>
    );
};

export default Actions;
